const FlyerFoot = ({flyerSettings, cinemaData}) => {
    const { titleBottomText } = flyerSettings

    if(titleBottomText || '' === titleBottomText ) {
        return <div className="website-url" dangerouslySetInnerHTML={{ __html: titleBottomText}}></div>
    } else if(cinemaData && cinemaData.website) {
        return <div className="website-url">{cinemaData.website}</div>
    } else {
        return ''
    }
}

export default FlyerFoot